import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import API, { UPLOADS_URL } from '../api/axios';

const AnnouncementPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [popupImage, setPopupImage] = useState(null);
  const location = useLocation();

  const isHomepage = location.pathname === '/' || location.pathname === '';

  useEffect(() => {
    // Only run on homepage
    if (!isHomepage) {
      setIsOpen(false);
      return;
    }

    // Attempt to fetch custom image from settings if available, else use default image
    API.get('/settings/public')
      .then(res => {
        const img = res.data?.data?.popup_image;
        if (img) {
          setPopupImage(`${UPLOADS_URL}/${img}`);
        } else {
          setPopupImage(`${process.env.PUBLIC_URL}/images/asmission-open.jpg`);
        }
      })
      .catch(() => {
        setPopupImage(`${process.env.PUBLIC_URL}/images/asmission-open.jpg`);
      });

    // Show popup after 5 seconds
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, [isHomepage]);

  const closePopup = () => {
    setIsOpen(false);
  };

  // Only render on homepage when open
  if (!isHomepage || !isOpen) return null;

  const imgSrc = popupImage || `${process.env.PUBLIC_URL}/images/asmission-open.jpg`;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm transition-opacity">
      <div className="relative max-w-lg w-full bg-white rounded-2xl shadow-2xl overflow-hidden animate-fade-down">
        <button
          onClick={closePopup}
          className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-black/60 hover:bg-black/80 text-white rounded-full transition-colors z-10"
          aria-label="Close Announcement"
        >
          <i className="fas fa-times text-sm"></i>
        </button>
        <img
          src={imgSrc}
          alt="Admission Announcement"
          className="w-full h-auto block"
          onError={(e) => {
            if (!e.currentTarget.dataset.fallbackTried) {
              e.currentTarget.dataset.fallbackTried = '1';
              e.currentTarget.src = `${process.env.PUBLIC_URL}/images/asmission-open.jpg`;
            }
          }}
        />
      </div>
    </div>
  );
};

export default AnnouncementPopup;
